import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DataManagementAppService } from 'src/app/services/data-management-app.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-data-preview',
  template: `
    <div *ngIf="waiting" class="fixed inset-0 flex justify-center items-center">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!waiting" class="dv-page">
      <div class="pv-hd">
        <div class="t">Data Preview (50 Records)</div>
        <div class="cnt">
          <span>Columns: <b>{{ dataPreview['no_of_columns'] }}</b></span>
          <span>Rows: <b>{{ dataPreview['no_of_rows'] }}</b></span>
        </div>
      </div>

      <div class="dtwrap">
        <table
          mat-table
          [dataSource]="dataPreview.first_50_records"
          class="dt demo-table"
        >
            <ng-container
              *ngFor="let colN of dataPreview.headers"
              [matColumnDef]="colN"
            >
              <th
                mat-header-cell
                *matHeaderCellDef
              >
                {{ colN }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
              >
                {{ element[colN] }}
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="dataPreview.headers"
              matHeaderRowDefStick
              class="header-row"
            ></tr>
            <tr
              mat-row
              style="height: 2.75rem;"
              *matRowDef="let row; columns: dataPreview.headers"
            ></tr>
          </table>
      </div>

      <div class="dv-foot">
        <button
          class="btn-primary"
          (click)="generateDescriptives()"
        >
          Continue
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./data-preview.component.scss'],
})
export class DataPreviewComponent implements OnInit {
  @Output() dataChanged = new EventEmitter<number>();
  waiting: boolean = true;
  dataSourceName: string | any = '';
  dataPreview = {
    first_50_records: [{}],
    no_of_rows: 0,
    no_of_columns: 0,
    headers: ['Loading...'],
  };
  constructor(
    private dataManagementServices: DataManagementAppService,
    private snackBar: SharedFeaturesService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.dataSourceName = this.route.snapshot.paramMap.get('data_name');
    if (this.dataSourceName) {
      this.dataManagementServices
        .getDataPreview(this.dataSourceName)
        .subscribe({
          next: (response: any) => {
            if (response) {
              let temp = JSON.parse(response['first_50_records']);
              this.dataPreview.headers = Object.keys(temp[0]);
              this.dataPreview.no_of_rows = response['no_of_rows'];
              this.dataPreview.no_of_columns = response['no_of_columns'];
              this.dataPreview.first_50_records = temp;
              this.waiting = false;
            }
          },
          error: (error: any) => {
            this.snackBar.openSnackBar(
              error.message,
              'Close',
              'error-snackbar'
            );
          },
        });
    }
  }

  generateDescriptives() {
    this.dataChanged.emit(2);
    this.router.navigate(['../../save', this.dataSourceName], {
      relativeTo: this.route,
    });
  }
}
